var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.merchantSupportLinkddress || _vm.merchantSupportEmailAddress)?_c('a',{staticClass:"link link--margin",attrs:{"id":"help-link","href":_vm.href,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" Need help? ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }